<template>
    <header class="z-20 bg-black">

        <div class="container mx-auto" v-if="type !== 'skinny'">
            <nav class="flex items-center justify-between flex-wrap py-5 px-2 md:px-0 w-full">
                <router-link to="/" class="flex items-center flex-no-shrink text-white md:mr-6 content-center">
                    <img src="@/assets/images/logo.png" class="navbar-logo h-8 sm:h-auto" />
                </router-link>

                <div class="block lg:hidden">
                    <button @click="toggle"
                        class="flex items-center px-3 py-2 border rounded text-white border-white-light hover:text-white hover:border-white focus:outline-none">
                        <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <title>Menu</title>
                            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                        </svg>
                    </button>
                </div>

                <div :class="open ? 'block' : 'hidden'" class="w-full lg:flex lg:items-center lg:w-auto">
                    <div class="lg:flex-grow lg:mr-10">
                        <router-link to="/map" active-class="text-white"
                            class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                            Map
                        </router-link>
                        <router-link to="/discover" active-class="text-white"
                            class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                            Discover
                        </router-link>
                        <router-link to="/features" active-class="text-white"
                            class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                            Features
                        </router-link>
                    </div>
                    <div class="flex">
                        <router-link to="/auth/login" active-class="text-white"
                            class="no-underline inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-black hover:bg-white mt-4 lg:mt-0"
                            v-if="userInfo == undefined || userInfo == null">
                            Sign In
                        </router-link>

                        <div class="relative" ref="dropdownMenu" v-if="userInfo !== undefined && userInfo !== null">
                            <div class="no-underline inline-block text-md leading-none border rounded border-white hover:border-transparent hover:text-black hover:bg-white mt-4 lg:mt-0 flex-no-wrap relative pin-r flex items-center align-center px-2 py-1"
                                :class="{ 'bg-white text-black': open, 'text-white': !open }" @click="open = !open">
                                <ProfileImage :userId="userInfo.id" class="h-6 w-6 rounded-full mr-2" /> {{ userInfo.name }}
                                <svg class="h-4 w-4 fill-current ml-1" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                            </div>
                            <div class="absolute pin-r mt-px" v-show="open">
                                <div class="bg-white shadow rounded overflow-hidden">
                                    <a href="#"
                                        class="no-underline block px-3 py-2 text-grey-darkest bg-white hover:text-white hover:bg-blue whitespace-no-wrap"
                                        v-on:click="performLogout()">Logout</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
        </div>

        <nav class="flex items-center justify-between flex-wrap py-2 px-4 w-full" v-if="type == 'skinny'">
            <router-link to="/" class="flex items-center flex-no-shrink text-white md:mr-6 content-center">
                <img src="@/assets/images/logo.png" class="navbar-logo" />
            </router-link>

            <div class="block lg:hidden">
                <button @click="toggle"
                    class="flex items-center px-3 py-2 border rounded text-white border-white-light hover:text-white hover:border-white focus:outline-none">
                    <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <title>Menu</title>
                        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                    </svg>
                </button>
            </div>

            <div :class="open ? 'block' : 'hidden'" class="w-full lg:flex lg:items-center lg:w-auto">
                <div class="lg:flex-grow lg:mr-10">
                    <router-link to="/map" active-class="text-white"
                        class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                        Map
                    </router-link>
                    <router-link to="/discover" active-class="text-white"
                        class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                        Discover
                    </router-link>
                    <router-link to="/features" active-class="text-white"
                        class="no-underline block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-2 lg:ml-2 rounded hover:bg-grey-darkest px-4 py-2">
                        Features
                    </router-link>
                </div>
                <div class="flex">
                    <router-link to="/auth/login" active-class="text-white"
                        class="no-underline inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-black hover:bg-white mt-4 lg:mt-0"
                        v-if="userInfo == undefined || userInfo == null">
                        Sign In
                    </router-link>

                    <div class="relative" ref="dropdownMenu" v-if="userInfo !== undefined && userInfo !== null">
                        <div class="no-underline inline-block text-md leading-none border rounded border-white hover:border-transparent hover:text-black hover:bg-white mt-4 lg:mt-0 flex-no-wrap relative pin-r flex items-center align-center px-2 py-1"
                            :class="{ 'bg-white text-black': open, 'text-white': !open }" @click="open = !open">
                            <ProfileImage :userId="userInfo.id" class="h-6 w-6 rounded-full mr-2" /> {{ userInfo.name }}
                            <svg class="h-4 w-4 fill-current ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                        <div class="absolute pin-r mt-px" v-show="open">
                            <div class="bg-white shadow rounded overflow-hidden">
                                <a href="#"
                                    class="no-underline block px-3 py-2 text-grey-darkest bg-white hover:text-white hover:bg-blue whitespace-no-wrap"
                                    v-on:click="performLogout()">Logout</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </nav>

    </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProfileImage from '@/components/Modules/ProfileImage';

export default {
    name: 'Navbar',
    data() {
        return {
            open: false,
        }
    },
    props: ['type'],
    components: {
        ProfileImage
    },
    computed: {
        ...mapGetters([
            'userInfo',
        ]),
    },
    methods: {
        ...mapActions([
            'logout',
        ]),
        toggle() {
            this.open = !this.open
        },
        performLogout() {
            this.logout()
        },
    },
}
</script>

<style>nav a {
    text-decoration: none;
}</style>
